import React, { useEffect, useRef } from 'react';
import ResetMap from "../../../core/resetMap.js";

const RelativitySlider = ({ globalRefs, globalState }) => {
    const setRelativitySliderAmount = globalState.setRelativitySliderAmount;
    const relativitySliderAmount = globalState.relativitySliderAmount;
    const setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
    const setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
    const mapRef = globalRefs.mapRef;
    const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    const debugMode = globalState.debugMode;

    const handleChange = (e) => {
        const value = Number(e.target.value);
        setGlobalPolygonTransparency(1);
        setMultuGroupSelectedArray([]);
        setRelativitySliderAmount(value);
    };

    const hasMountedRelativitySlider = useRef(false);

    useEffect(() => {
        if (!hasMountedRelativitySlider.current) {
            hasMountedRelativitySlider.current = true;
            return;
        }
        if (
            mapRef.current !== null &&
            longstandingGeoJSONRef !== null
        ) {
            if (debugMode) {
                const timestamp = new Date().toISOString();
                console.log(timestamp + " " + "🎉 resetting map following a relativity update")
            }
            ResetMap(globalRefs, globalState);
        }
    }, [
        globalState.relativitySliderAmount
    ]);

    return (
        <div
            style={{
                width: '100%',
            }}
        >
            <div
                style={{
                    textAlign: 'left',
                    marginBottom: '4px',
                    fontSize: '11px',
                    color: '#687975',
                }}
            >
                <b>Scale: {relativitySliderAmount.toFixed(1)}</b>
            </div>

            <input
                className="relativity-slider"
                type="range"
                min="0"
                max="2"
                step="0.1"
                value={relativitySliderAmount}
                onChange={handleChange}
                style={{ width: '100%', margin: 0 }}
            />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '10px',
                    marginTop: '2px',
                    color: '#687975',
                }}
            >
                <span>0.0</span>
                <span>2.0</span>
            </div>
        </div>
    );
};

export default RelativitySlider;
